import create, { StateCreator } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { AccountState, createAccountSlice } from "./slices/accountSlice";
import { ArchiveState, createArchiveSlice } from "./slices/archiveSlice";

export type RootState = {
  archiveDataState: ArchiveState;
  accountDataState: AccountState;
};

export type StoreState<T extends Object> = StateCreator<
  RootState,
  [
    ["zustand/devtools", never],
    ["zustand/persist", unknown],
    ["zustand/immer", unknown]
  ],
  [],
  T
>;

// Not persisting data for security reasons
const useStore = create<RootState>()(
  devtools(
    persist(
      immer((...actions) => ({
        archiveDataState: createArchiveSlice(...actions),
        accountDataState: createAccountSlice(...actions),
      })),
      {
        name: "persisted-ai-excel-bot-store",
        getStorage: () => localStorage,
        // @ts-ignore
        merge: (persisted: RootState, current): RootState => {
          return {
            archiveDataState: Object.assign(
              current.archiveDataState,
              persisted.archiveDataState
            ),
            accountDataState: Object.assign(
              current.accountDataState,
              persisted.accountDataState
            ),
          };
        },
      }
    ),
    {
      name: "ai-excel-bot-store",
    }
  )
);

export default useStore;
